<template>
  <v-container>
    <v-row>
      <v-col>
        <h1 class="display-1">i-Buzz 探網格式產生器</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="2">
        <v-text-field
          v-model="search"
          v-on:keyup.enter="getChannelData"
          append-icon="search"
          label="頻道名稱"
          placeholder="搜尋頻道中文名稱"
          single-line
          hide-details
          :height="33"
        ></v-text-field>
      </v-col>
      <v-col cols="1">
        <v-select :items="unique_type" label="選擇型式" v-model="filtered_type"></v-select>
      </v-col>
      <v-col cols="1">
        <v-text-field
          v-model="filtered_website"
          v-on:keyup.enter="getChannelData"
          append-icon="search"
          label="網站名稱"
          placeholder="搜尋網站名稱"
          single-line
          hide-details
          :height="33"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select
          v-model="filtered_industry"
          :items="industries"
          label="選擇產業分類"
          :multiple="false"
          :height="33"
        ></v-select>
      </v-col>
      <v-col cols="1">
        <v-select v-model="filterStatusNo" :items="status" label="頻道狀態"></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="data"
          :single-select="false"
          :search="search"
          item-key="tkfc_name"
          show-select
          multi-sort
          class="elevation-1"
          :footer-props="{
              itemsPerPageOptions: [10,25,50,75,100]
          }"
        ></v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-pagination v-model="page" :length="this.page_length" :total-visible="10"></v-pagination>
      </v-col>
    </v-row>
    <!-- 這邊放選擇的結果（ini） -->
    <v-row>
      <v-textarea name="input-7-1" filled label="OUTPUT" auto-grow :value="selected_ini"></v-textarea>
    </v-row>
    <v-row>
      <v-col>
        <v-alert type="warning" v-if="selected_num == 0 ">您並未選擇頻道</v-alert>
        <v-alert type="warning" v-if="selected_num > 1000 ">您選了超過 1000 個頻道</v-alert>
      </v-col>
    </v-row>
    <!-- 已選頻道列表 -->
    <v-row>
      <v-col>
        <div class="text-center pb-2">
          <v-btn
            color="normal"
            @click="showShortSelectedChannels=!showShortSelectedChannels"
          >{{ showShortSelectedChannels? "關閉":"顯示"}}已選頻道</v-btn>
        </div>
        <v-card class="mx-auto" outlined v-if="showShortSelectedChannels">
          <v-card-text>
            <v-chip
              class="ma-2"
              close
              @click:close="removeChannel($event, channel.tkfc_name)"
              v-for="(channel, index) in selected"
              :key="index"
              v-bind:class="{'pink lighten-3': channel.tw_status === false, 'indigo lighten-3': channel.tw_status === true}"
            >{{channel.display_name}}</v-chip>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- 已選頻道列表結束 -->
    <v-row>
      <v-col>
        <div>
          <a
            href="http://api.i-buzz-system.com/load-data/downloads/inner-tool/bangyan-sample.xlsx"
          >PRO 範例檔案</a>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-file-input
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          label="PRO excel 檔案"
          v-model="file"
        ></v-file-input>
      </v-col>
      <v-col cols="2">
        <div class="my-2">
          <v-btn color="primary" id="sendData" @click="sendData" :disabled="sendBtnStatus">送出</v-btn>
          <v-progress-circular class="ma-2" indeterminate color="amber" v-if="showLoadingBar"></v-progress-circular>
        </div>
      </v-col>
      <v-col cols="6">
        <div v-if="errorMessage">
          <p class="body-1">
            <span v-html="errorMessage"></span>
          </p>
        </div>
        <div>
          <v-btn color="primary" :href="responseData" v-if="responseData">下載</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import Axios from "axios";
import store from "@/store";
// import data from "../assets/data/full_ibk3_channel.json";
import axios from "axios";

export default {
  name: "ChannelData",

  data: () => ({
    data: null,
    data_bk: null,
    selected: [],
    selected_num: 0,
    selected_channel_sum: 0,
    unique_website: [],
    filtered_website: "",
    unique_type: [
      "forum",
      "blog",
      "article",
      "news",
      "sns",
      "wiki"
    ],
    filtered_type: "",
    industries: [],
    filtered_industry: "",
    search: "",
    search_website: "",
    file: null,
    page: 1,
    page_length:6,
    responseData: null,
    errorMessage: null,
    showLoadingBar: false,
    sendBtnStatus: false,
    filterStatusNo: "",
    status: ["Yes","No"],
    showShortSelectedChannels: false,
    headers: [
      {
        text: "頻道英文",
        align: "start",
        sortable: false,
        value: "tkfc_name",
        filterable: false
      },
      { text: "頻道中文名", value: "display_name" },
      { text: "網站", value: "website", filterable: false },
      //   { text: "url", value: "url" },
      { text: "型式", value: "tw_type" },
      // { text: "圖檔路徑", value: "img_path", filterable: false },
      { text: "狀態", value: "tw_status", filterable: false },
      { text: "備註", value: "note", filterable: false }
      // { text: "頻道數", value: "channel_count", filterable: false }
    ]
  }),
  beforeMount: function() {
    this.data = this.getChannelData();
    // this.data_bk = this.data;
    this.industries = this.getIndustries();
  },
  updated: function() {
    if (!this.file) {
      this.sendBtnStatus = true;
    } else {
      this.sendBtnStatus = false;
    }
    if (this.responseData || this.errorMessage) {
      this.showLoadingBar = false;
    }
    this.selected_num = this.selected.length;
  },
  beforeUpdate: function() {
    // 計算選擇的數量
    this.selected_channel_sum = 0;
    for (var n = 0; n < this.selected.length; n++) {
      this.selected_channel_sum += this.selected[n].tw_channel_number;
    }
    if (this.file == null) {
      this.responseData = null;
      this.errorMessage = null;
    }
  },
  // mounted: function() {
  //   for (var n = 0; n < this.data.length; n++) {
  //     if (this.unique_website.includes(this.data[n].website)) {
  //       continue;
  //     } else {
  //       this.unique_website.push(this.data[n].website);
  //     }
  //   }
  // },
  computed: {
    selected_ini: function() {
      var result = "";
      // result = result.concat(
      //   "count.網站頻道=" + this.selected_channel_sum + "\n\n"
      // );
      result = result.concat("count.網站=" + this.selected_num + "\n\n");
      for (var n = 0; n < this.selected.length; n++) {
        result = result.concat(
          "網站_" + n + "=" + this.selected[n].tkfc_name + "\n"
        );
        result = result.concat(
          this.selected[n].tkfc_name +
            "_名稱=" +
            this.selected[n].display_name +
            "\n"
        );
        result = result.concat(
          this.selected[n].tkfc_name +
            "_網站=" +
            this.selected[n].website +
            "\n"
        );
        result = result.concat(
          this.selected[n].tkfc_name +
            "_型式=" +
            this.selected[n].tw_type +
            "\n"
        );
        result = result.concat(
          this.selected[n].tkfc_name +
            "_圖檔=" +
            this.selected[n].picture +
            "\n"
        );
        result = result.concat(
          this.selected[n].tkfc_name +
            "_頻道=" +
            this.selected[n].tw_channel_number +
            "\n\n"
        );
      }
      return result;
    }
  },
  watch: {
    filtered_type:function () {
      this.data = this.getChannelData()
    },
    filtered_industry:function () {
      this.data = this.getChannelData()
    },
    page: function () {
      this.data = this.getChannelData();
    },
    filterStatusNo:function () {
      this.data = this.getChannelData()
    }
  },
  methods: {
    getChannelData: function() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + store.getters.getToken
        }
      };
      Axios.get(
        "https://api.i-buzz-system.com/basic/channelmanage/IBK3Channel?display_name="+this.search+"&media_type="+this.filtered_type+"&website="+this.filtered_website+"&industry="+this.filtered_industry+"&status="+this.filterStatusNo+"&page="+this.page,
        config
      )
      .then(response => {
        this.data = response.data.data;
        this.page_length = parseInt(response.data.total_count/100);
        // this.data_bk = response.data.data;
      })
      .catch(error => {
        // window.location.href = "/"
        console.log(error);
      });
    },
    getIndustries: function() {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + store.getters.getToken
        }
      };
      Axios.get(
        "https://api.i-buzz-system.com/basic/channelmanage/get-industry",
        config
      )
      .then(response => {
        this.industries = response.data.data;
      })
      .catch(error => {
        console.log(error);
      });
    },
    sendData: function() {
      this.showLoadingBar = true;
      var postforms = new FormData();
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*"
        }
      };
      postforms.append("excelpro", this.file, this.file.name);
      postforms.append("channel", this.selected_ini);
      axios
        .post(
          "https://wom.i-buzz-system.com/api/pro-generator",
          postforms,
          config
        )
        .then(response => {
          // console.log(response);
          this.responseData = response.data.link;
        })
        .catch(error => {
          console.log(error);
          // console.log(error.response.data.msg)
          this.errorMessage = error.response.data.msg;
        });
    },
    removeChannel: function($event, channel) {
      var changed_channels = [];
      for (var c = 0; c < this.selected.length; c++) {
        if (channel !== this.selected[c].tkfc_name) {
          changed_channels.push(this.selected[c]);
        }
      }
      this.selected = changed_channels;
    },
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
  }
};
</script>